import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BsFillEyeFill } from 'react-icons/bs'
import { Icon, Radio, message, Button } from 'antd'
import { Link } from 'react-router-dom'
import Formsy from 'formsy-react'
import findIndex from 'lodash.findindex'
import Card from '../Card'
import DriverContactModal from '../Modals/DriverContactModal'
import CustomInput from '../CustomInput'
import CustomTable from '../CustomTable'
import ProfilePictureInput from '../ProfilePictureInput'
import CoverPictureInput from '../CoverPictureInput'
import inputValidations from '../../utils/inputValidations'
import {
  saveNewDriver,
  updateDriverInfo,
} from '../../screens/NewDriver/actions'
import css from './index.scss'
import CnhHelperModal from '../CnhHelperModal'

const style = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
  },
}

class NewDriverView extends Component {
  state = {
    modalVisible: false,
    profileImage: '',
    cnhImage: '',
    name: this.props.name,
    cpf: this.props.cpf,
    phone: '',
    birthDate: this.props.birthDate,
    cnhExpeditionDate: '',
    cnhValidDate: '',
    cnhNumber: '',
    genre: this.props.gender || 'MASCULINO',
    contacts: [],
    lastPositionLatitude: 0,
    lastPositionLongitude: 0,
    viewCnh: false,
  };
  headers = [
    {
      field: 'name',
      label: 'Nome',
    },
    {
      field: 'formattedValue',
      label: 'Telefone',
    },
    {
      label: '',
      value: 'options',
      componentToRender: (cell, row) => (
        <button
          className={css.tableButton}
          onClick={() => {
            this.handleDeleteContact(row)
          }}
        >
          <Icon type="delete" style={{ color: '#7906a9' }} />
        </button>
      ),
      customWidth: '30',
    },
  ];

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.data) {
      this.setState({
        id: nextProps.data.id,
        modalVisible: false,
        profileImage: nextProps.data.profileImage,
        cnhImage: nextProps.data.cnhImage,
        name: nextProps.data.name,
        cpf: nextProps.data.cpf,
        phone: nextProps.data.phone,
        birthDate: nextProps.data.birthDate,
        cnhExpeditionDate: nextProps.data.cnhExpeditionDate,
        cnhValidDate: nextProps.data.cnhValidDate,
        cnhNumber: nextProps.data.cnhNumber,
        cnhRegister: nextProps.data.cnhRegister,
        genre: nextProps.data.genre,
        contacts: [],
        lastPositionLatitude: 0,
        lastPositionLongitude: 0,
      })
    }
    return null
  }

  handleDeleteContact = (contact) => {
    const index = findIndex(
      this.state.contacts,
      item => item.value === contact.value,
    )
    if (index > -1) {
      this.setState({
        contacts: [
          ...this.state.contacts.slice(0, index),
          ...this.state.contacts.slice(index + 1),
        ],
      })
    }
  };

  handleSaveNewDriver = () => {
    if (this.props.data) {
      this.props.updateDriver(this.state)
    } else {
      this.props.saveNewDriver(this.state, true)
    }
  };
  handleViewCnh = () => {
    this.setState(p => ({ ...p, viewCnh: !p.viewCnh }))
  };
  handleSubmit = (e) => {
    e.preventDefault()
    this.buttonSub.click()
  };
  toggleModal = () => {
    this.setState({ modalVisible: true })
  };
  addDriverContact = (contact) => {
    this.setState(prevState => ({
      modalVisible: false,
      contacts: [...prevState.contacts, contact],
    }))
  };

  renderDriverHelp = (props) => {
    const handleViewCnh = this.handleViewCnh
    return (
      <React.Fragment>
        <BsFillEyeFill
          className={css.icon}
          onClick={handleViewCnh}
          {...props}
        />
      </React.Fragment>
    )
  };
  render() {

    const defaultValues = this.props.defaultValues === 'create'
    return (
      <div style={style.container}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ flex: 0.6 }}>
            <Card style={{ width: '100%', padding: 16 }}>
              {defaultValues ?  (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginTop: 16,
                      marginRight: 54,
                    }}
                  >
                    <ProfilePictureInput
                      width={140}
                      height={140}
                      iconWidth={100}
                      iconHeight={100}
                      iconMarginTop={13}
                      iconMarginBottom={10}
                      textValue="Insira a foto"
                      icon="profile"
                      uploadPicture={(payload) => {
                        this.setState({
                          profileImage: payload.file,
                        })
                      }}
                      fileUploaded={this.state.profileImage}
                      onError={(errorMessage) => {
                        message.error(errorMessage)
                      }}
                    />
                    <div
                      style={{
                        height: 1,
                        backgroundColor: '#979797',
                        marginTop: 20,
                        marginBottom: 30,
                      }}
                    />
                    <CoverPictureInput
                      width={140}
                      height={80}
                      image={this.props.document}
                      iconWidth={45}
                      iconHeight={45}
                      iconMarginTop={14}
                      icon="id-card"
                      textValue="CNH do motorista"
                      uploadPicture={(payload) => {
                        this.setState({
                          cnhImage: payload.file,
                        })
                      }}
                      fileUploaded={this.state.cnhImage}
                      onError={(errorMessage) => {
                        message.error(errorMessage)
                      }}
                    />
                    <div style={{ marginBottom: 20 }} />
                  </div>
                </div>
              ) : null}
              <Formsy
                onValidSubmit={this.handleSaveNewDriver}
                className={css.form}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    marginTop: 12,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexDirection: 'column',
                    }}
                  >
                    <CustomInput
                      label="Nome completo *"
                      name="name"
                      placeholder="Nome completo"
                      inputStyle={{ width: '100%' }}
                      formStyle={{ margin: 8 }}
                      onChange={e => this.setState({ name: e.target.value })}
                      value={this.state.name}
                      validations="minLength:6"
                      validationError="Digite um nome com no mínimo 6 caracteres."
                      required
                      disabled={this.props.disabledName}
                      errorClassName={css.errorClassName}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    marginTop: 12,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexDirection: 'column',
                    }}
                  >
                    <CustomInput
                      label="CPF *"
                      name="cpfCnpj"
                      mask="cpf"
                      placeholder="CPF"
                      inputStyle={{ width: 180 }}
                      formStyle={{ margin: 8 }}
                      onValueChange={value => this.setState({ cpf: value })}
                      value={this.state.cpf}
                      {...inputValidations('cpf')}
                      required
                      disabled={this.props.disabledCPF}
                      errorClassName={css.errorClassName}
                    />
                  </div>
                  <div style={{ display: 'flex', flex: 1 }}>
                    <CustomInput
                      label="Telefone *"
                      name="phone"
                      mask="phone"
                      placeholder="Telefone"
                      inputStyle={{ width: 180 }}
                      formStyle={{ margin: 8 }}
                      onValueChange={value => this.setState({ phone: value })}
                      value={this.state.phone}
                      validations={{ minLength: 10, maxLength: 11 }}
                      validationErrors={{
                        minLength: 'Telefone inválido.',
                        maxLength: 'Telefone inválido.',
                      }}
                      errorClassName={css.errorClassName}
                      required
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    marginTop: 12,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexDirection: 'column',
                    }}
                  >
                    <CustomInput
                      label="Data de nascimento *"
                      name="birthDate"
                      mask="date"
                      placeholder="Data de nascimento"
                      inputStyle={{ width: 180 }}
                      formStyle={{ margin: 8 }}
                      onValueChange={(value, formattedValue) =>
                        this.setState({ birthDate: formattedValue })
                      }
                      value={this.state.birthDate}
                      validations="isLength:10"
                      validationError="Data inválida."
                      disabled={this.props.disabledBirthDate}
                      errorClassName={css.errorClassName}
                      required
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexDirection: 'column',
                    }}
                  >
                    <span className={css.inputLabel} style={{ marginTop: 6 }}>
                      Gênero *
                    </span>
                    <Radio.Group
                      defaultValue={this.state.genre}
                      buttonStyle="solid"
                      size="small"
                      value={this.state.genre}
                      onChange={e => this.setState({ genre: e.target.value })}
                      disabled={this.props.disabledGender}
                      style={{ margin: 8 }}
                    >
                      <Radio.Button value="MASCULINO">Masculino</Radio.Button>
                      <Radio.Button value="FEMININO">Feminino</Radio.Button>
                    </Radio.Group>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    marginTop: 12,
                  }}
                >
                  <div
                    style={{ flex: 1, marginLeft: 8, marginTop: 2 }}
                  >
                    <label className={css.inputLabel} style={{ marginLeft: 1, display: 'flex', alignItems: 'center' }}>Número de registro CNH*
                      {this.renderDriverHelp()}
                    </label>
                    <CustomInput
                      name="cnhRegister"
                      type="number"
                      placeholder="Número de registro CNH"
                      inputStyle={{ width: 180 }}
                      errorClassName={css.errorClassName}
                      onChange={e =>
                        this.setState({ cnhRegister: e.target.value })
                      }
                      value={this.state.cnhRegister}
                      maxLength={11}
                      validations="minLength:6,maxLength:11"
                      validationErrors={{
                        minLength:
                          'Digite um código com no mínimo 6 caracteres.',
                        maxLength:
                          'Digite um código com no máximo 11 caracteres.',
                      }}
                      required
                    />
                  </div>
                  <div
                    style={{ flex: 1, marginLeft: 8, marginTop: 2 }}
                  >
                    <label className={css.inputLabel} style={{ marginLeft: 1, display: 'flex', alignItems: 'center' }}>Número da CNH*
                      {this.renderDriverHelp()}

                    </label>
                    <CustomInput
                      errorClassName={css.errorClassName}
                      name="cnhNumber"
                      type="number"
                      placeholder="Número da CNH"
                      inputStyle={{ width: 180 }}
                      onChange={e =>
                        this.setState({ cnhNumber: e.target.value })
                      }
                      value={this.state.cnhNumber}
                      maxLength={10}
                      validations="minLength:6,maxLength:10"
                      validationErrors={{
                        minLength:
                          'Digite um código com no mínimo 6 caracteres.',
                        maxLength:
                          'Digite um código com no máximo 10 caracteres.',
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    marginTop: 30,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexDirection: 'column',
                    }}
                  >
                    <CustomInput
                      label="Data de emissão CNH"
                      name="cnhExpeditionDate"
                      mask="date"
                      placeholder="Data de emissão CNH"
                      inputStyle={{ width: 180 }}
                      formStyle={{ margin: 8 }}
                      onValueChange={(value, formattedValue) =>
                        this.setState({ cnhExpeditionDate: formattedValue })
                      }
                      value={this.state.cnhExpeditionDate}
                      validations="isLength:10"
                      validationError="Data inválida."
                      errorClassName={css.errorClassName}
                    />
                  </div>
                  <div style={{ display: 'flex', flex: 1 }}>
                    <CustomInput
                      label="Data de validade CNH"
                      name="cnhValidDate"
                      mask="date"
                      placeholder="Data de validade CNH"
                      inputStyle={{ width: 180 }}
                      formStyle={{ margin: 8 }}
                      onValueChange={(value, formattedValue) =>
                        this.setState({ cnhValidDate: formattedValue })
                      }
                      value={this.state.cnhValidDate}
                      validations="isLength:10"
                      validationError="Data inválida."
                      errorClassName={css.errorClassName}
                    />
                  </div>
                </div>
                <p
                  style={{
                    fontFamily: 'GloberRegular',
                    fontSize: 13,
                    margin: 8,
                  }}
                >
                  (*) Campo obrigatório
                </p>
                <button
                  ref={(node) => {
                    this.buttonSub = node
                  }}
                  type="submit"
                  style={{ display: 'none' }}
                />
              </Formsy>
            </Card>
            <div className={css.row} style={{ marginTop: 16 }}>
              {this.props.showAllDriversButton ? (
                <Link to="/drivers" target="_blank" style={{ width: '50%' }}>
                  <Button
                    style={{ paddingLeft: 24, paddingRight: 24 }}
                    icon="eye"
                  >
                    Ver todos os motoristas
                  </Button>
                </Link>
              ) : (
                <div />
              )}
              <Button
                type="primary"
                style={{ paddingLeft: 24, paddingRight: 24 }}
                onClick={this.handleSubmit}
              >
                Salvar motorista
              </Button>
            </div>
          </div>
          {defaultValues ?  (
            <div style={{ flex: 0.3, marginLeft: 16 }}>
              <span className={css.title}>Contatos/Referências</span>
              <CustomTable
                data={this.state.contacts}
                headers={this.headers}
                noDataMessage="Nenhum contato adicionado."
              />
              <Button
                icon="plus"
                style={{ margin: 8, marginTop: 12 }}
                onClick={this.toggleModal}
                type="primary"
              >
                Novo contato
              </Button>
            </div>
          ) : null}
        </div>
        {defaultValues && (
          <CnhHelperModal
            visible={this.state.viewCnh}
            onCancel={this.handleViewCnh}
            footer={null}
          />
        )}
        <DriverContactModal
          showModal={this.state.modalVisible}
          hideContactModal={() => {
            this.setState({
              modalVisible: false,
            })
          }}
          addDriverContact={this.addDriverContact}
        />
      </div>
    )
  }
}

const mapActionsToProps = dispatch => ({
  saveNewDriver(payload, selectDriver) {
    dispatch(saveNewDriver(payload, selectDriver))
  },
  updateDriver(payload) {
    dispatch(updateDriverInfo(payload))
  },
})

export default connect(null, mapActionsToProps)(NewDriverView)
